import {useReports} from '@sail/observability';
import {once} from '@sail/utils';
import {useContext} from 'react';
import IntlConfigContext from 'src/internal/config/IntlConfigContext';
import defaultConfig from 'src/internal/config/defaultConfig';

import type {IReports} from '@sail/observability';
import type {IntlConfig} from 'src/types';

class IntlConfigError extends Error {
  constructor(message: string) {
    super(`[@sail/intl] ${message}`);
  }
}

const reportUninitializedErrorOnce = once((report: IReports['error']) => {
  const error = new IntlConfigError(
    'Make sure to provide the required config for intl to IntlProvider upon initialization.',
  );

  report(error, {
    tags: {namespace: 'intl'},
  });
});

export default function useIntlConfig(): IntlConfig {
  const config = useContext(IntlConfigContext);
  const {error} = useReports();

  if (config === defaultConfig) {
    reportUninitializedErrorOnce(error);
  }

  return config;
}
